import { authStore } from 'src/stores/auth';
import create from 'zustand';

export const useAuth = create(authStore);
